const EnterBar = () => import(/* webpackChunkName:"chunk-actbar" */ '../views/P5_Activitys/ActEnterBar/index.vue')

const BeerAct = () => import(/* webpackChunkName:"chunk-beeract" */ '../views/P5_Activitys/BeerCollect')

const CallMotivation = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/index.vue')
const CallMotivationRules = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/rules.vue')

// 动态页面容器
const DyPage = () => import(/* webpackChunkName:"chunk-dypage" */ '../views/P5_Activitys/DyPage/index.vue')

const Incentive = () => import(/* webpackChunkName:"chunk-incentive" */ '../views/P5_Activitys/Incentive/index.vue')
const IncentiveForNew = () => import(/* webpackChunkName:"chunk-incentivefornew" */ '../views/P5_Activitys/IncentiveForNew/index.vue')

const InviteEarn = () => import(/* webpackChunkName:"chunk-inviteearn" */ '../views/P5_Activitys/InviteEarn/index.vue')

const Liveness = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/index.vue')
const LivenessRules = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/rules.vue')

const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchingtopay" */ '../views/P5_Activitys/MatchingToPay/index.vue')

const NewguyWheelPan = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/index.vue')
const NewguyWheelPanRules = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/rules.vue')

const NineDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineDotNinetyNine" */ '../views/P5_Activitys/NineDotNinetyNine/index.vue')

const NineteenDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineteenDotNinetyNine" */ '../views/P5_Activitys/NineteenDotNinetyNine/index.vue')

const PrivateCallIncome = () => import(/* webpackChunkName:"chunk-privatecall" */ '../views/P5_Activitys/PrivateCallIncome')

const RechargeAfterFirst = () => import(/* webpackChunkName:"chunk-rechargeAfterFirst" */ '../views/P5_Activitys/RechargeAfterFirst/index.vue')

const RechargeFirst = () => import(/* webpackChunkName:"chunk-rechargefirst" */ '../views/P5_Activitys/RechargeFirst/index.vue')

const RechargeLowSmall = () => import(/* webpackChunkName:"chunk-rechargeLowSmall" */ '../views/P5_Activitys/RechargeLowSmall/index.vue')

const RechargeMidR = () => import(/* webpackChunkName:"chunk-rechargeMidR" */ '../views/P5_Activitys/RechargeRUser/midR.vue')
const RechargeTopR = () => import(/* webpackChunkName:"chunk-rechargeTopR" */ '../views/P5_Activitys/RechargeRUser/topR.vue')

const Repurchase = () => import(/* webpackChunkName:"chunk-repurchase" */ '../views/P5_Activitys/Repurchase/index.vue')

const SubAgentEvent = () => import(/* webpackChunkName:"chunk-subagentevent" */ '../views/P5_Activitys/SubAgentEvent/index.vue')

const ActArMainFemale = () => import(/* webpackChunkName:"chunk-actar" */ '../views/P5_Activitys/ActAr/actFemaleMain.vue')
const ActArRankFemale = () => import(/* webpackChunkName:"chunk-actar" */ '../views/P5_Activitys/ActAr/actFemaleRank.vue')
const ActArRulesFemale = () => import(/* webpackChunkName:"chunk-actar" */ '../views/P5_Activitys/ActAr/actFemaleRules.vue')
const ActArMainMale = () => import(/* webpackChunkName:"chunk-actar" */ '../views/P5_Activitys/ActAr/actMaleMain.vue')
const ActArRecordsMale = () => import(/* webpackChunkName:"chunk-actar" */ '../views/P5_Activitys/ActAr/actMaleRecords.vue')
const ActArRulesMale = () => import(/* webpackChunkName:"chunk-actar" */ '../views/P5_Activitys/ActAr/actMaleRules.vue')

const Halloween2025MainMale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActMaleMain.vue')
const Halloween2025RankMale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActMaleRank.vue')
const Halloween2025RulesMale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActMaleRules.vue')
const Halloween2025MainFemale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActFemaleMain.vue')
const Halloween2025RankFemale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActFemaleRank.vue')
const Halloween2025RulesFemale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActFemaleRules.vue')

const routes = [
  // 运营位
  {
    path: '/act-enter', name: 'act-enter', component: EnterBar, meta: { hideVConsole: true }
  },
  // 啤酒收集节
  {
    path: '/beer-collect', name: 'beer-collect', component: BeerAct
  },
  // 男用户通话激励
  {
    path: '/call-motivation', name: 'call-motivation', component: CallMotivation
  },
  {
    path: '/call-motivation-rules', name: 'call-motivation-rules', component: CallMotivationRules
  },

  // 自定义图片页面
  {
    path: '/dy-page/:customPageId', name: 'dy-page', component: DyPage
  },
  // 激励活动
  {
    path: '/incentive-act', name: 'incentive-act', component: Incentive
  },
  // 新用户激励活动
  {
    path: '/incentive-fornew', name: 'incentive-fornew', component: IncentiveForNew
  },
  // 分享裂变
  {
    path: '/invite-earn', name: 'invite-earn', component: InviteEarn
  },
  // 升级奖励
  {
    path: '/liveness', name: 'liveness', component: Liveness
  },
  {
    path: '/liveness-rules', name: 'liveness-rules', component: LivenessRules
  },
  // match
  {
    path: '/matching-to-pay', name: 'matching-to-pay', component: MatchingToPay
  },
  // 新用户转盘
  {
    path: '/newguy-wheel-pan', name: 'newguy-wheel-pan', component: NewguyWheelPan
  },
  {
    path: '/newguy-wheel-pan-rules', name: 'newguy-wheel-pan-rules', component: NewguyWheelPanRules
  },
  // 充值活动9.99
  {
    path: '/recharge-ninepointninety', name: 'nine-dot-ninetynine', component: NineDotNinetyNine
  },
  // 充值活动19.99
  {
    path: '/nineteen-ninety_nine', name: 'nineteen-dot-ninetynine', component: NineteenDotNinetyNine
  },
  // 主播限时付费电话补贴
  {
    path: '/private-call-income', name: 'private-call-income', component: PrivateCallIncome
  },
  // 充值-次充
  {
    path: '/recharge-afterfirst', name: 'recharge-afterfirst', component: RechargeAfterFirst
  },
  // 充值-首充
  {
    path: '/recharge-first', name: 'recharge-first', component: RechargeFirst
  },
  // 低频小额用户充值
  {
    path: '/recharge-low-small', name: 'recharge-low-small', component: RechargeLowSmall
  },
  // 中小R用户充值
  {
    path: '/recharge-mid-r', name: 'recharge-mid-r', component: RechargeMidR
  },
  // 大R用户充值
  {
    path: '/recharge-top-r', name: 'recharge-top-r', component: RechargeTopR
  },
  // 复购
  {
    path: '/repurchase', name: 'repurchase', component: Repurchase
  },
  // 二级代理活动
  {
    path: '/sub-agent-event', name: 'sub-agent-event', component: SubAgentEvent
  },
  // act-tr（女用户）
  {
    path: '/act-tr-female-main', name: 'act-tr-female-main', component: ActArMainFemale
  },
  {
    path: '/act-tr-female-rank', name: 'act-tr-female-rank', component: ActArRankFemale
  },
  {
    path: '/act-tr-female-rules', name: 'act-tr-female-rules', component: ActArRulesFemale
  },
  // act-tr（男用户）
  {
    path: '/act-tr-male-main', name: 'act-tr-male-main', component: ActArMainMale, meta: { keepAlive: true }
  },
  {
    path: '/act-tr-male-records', name: 'act-tr-male-records', component: ActArRecordsMale
  },
  {
    path: '/act-tr-male-rules', name: 'act-tr-male-rules', component: ActArRulesMale
  },
  // 万圣节-男用户主页（未开始：预热页；开始后：任务页）
  {
    path: '/halloween2025-main-male', name: 'holiday-main-male', component: Halloween2025MainMale
  },
  // 万圣节-男用户排行（未开始：积分排行；开始后：礼物排行）
  {
    path: '/halloween2025-rank-male', name: 'halloween2025-rank-male', component: Halloween2025RankMale
  },
  // 万圣节-男用户规则
  {
    path: '/halloween2025-rules-male', name: 'halloween2025-rules-male', component: Halloween2025RulesMale
  },
  // 万圣节-女用户主页（未开始：预热页；开始后：主页面）
  {
    path: '/halloween2025-main-female', name: 'halloween2025-main-female', component: Halloween2025MainFemale
  },
  // 万圣节-女用户排行（未开始：积分排行；开始后：礼物排行）
  {
    path: '/halloween2025-rank-female', name: 'halloween2025-rank-female', component: Halloween2025RankFemale
  },
  // 万圣节-女用户规则
  {
    path: '/halloween2025-rules-female', name: 'halloween2025-rules-female', component: Halloween2025RulesFemale
  },
]
export default routes
